import React, { FC, memo, useCallback } from "react";
import { setClass } from "@utils";
import { Checkbox } from "../checkbox";
import { DatePicker } from "../datePicker";
import { Input } from "../input";
import { Select } from "../select2";
import "../../styles/components/filterOption.scss";

type TFilterMode = "multiple" | "select" | "input" | "checkbox" | "date";
interface FilterOptionProps {
  title: string;
  options?: unknown[];
  mode: TFilterMode;
  search?: boolean;
  // TODO: подумать как избавиться от any
  value?: any;
  startDate?: Date;
  endDate?: Date;
  inputValue?: string;
  className?: string;
  placeholder?: string;
  placeholderWhenNoFilteredItems?: string;
  disabled?: boolean;
  commonContent?: boolean;
  defaultValue?: unknown;
  isPlaceholderMinDate?: boolean;
  isPlaceholderMaxDate?: boolean;
  renderOption?: (item: unknown, isSelected: boolean) => JSX.Element;
  onChange?: (value: unknown | unknown[]) => void;
  onChangeStartDate?: (startDate: Date) => void;
  onChangeEndDate?: (endDate: Date) => void;
  getOptionLabel?: (option: unknown) => string;
  getOptionId?: (option: unknown) => string | number;
  clearOnSelect?: boolean;
}

export const FilterOption: FC<FilterOptionProps> = memo(
  ({
    title,
    options,
    mode,
    search,
    value,
    startDate,
    endDate,
    inputValue,
    placeholder,
    className,
    placeholderWhenNoFilteredItems,
    disabled,
    commonContent,
    defaultValue,
    isPlaceholderMinDate,
    isPlaceholderMaxDate,
    renderOption,
    onChange,
    onChangeEndDate,
    onChangeStartDate,
    getOptionLabel,
    getOptionId,
    clearOnSelect = true,
  }) => {
    const onCleared = () =>
      onChange(Array.isArray(value) ? [] : defaultValue ?? null);

    const checkIsChoosedDay = useCallback(
      (day: Date) =>
        day.getTime() > startDate.getTime() &&
        day.getTime() <= endDate.getTime(),
      [startDate, endDate]
    );

    return (
      <div className={setClass("filter-option", className)}>
        <p className="filter-labels">{title}</p>
        {mode === "multiple" && (
          <Select
            value={value}
            onChange={onChange}
            options={options}
            placeholder={placeholder}
            multiple
            search={search}
            renderOption={renderOption}
            placeholderWhenNoFilteredItems={placeholderWhenNoFilteredItems}
            commonContent={commonContent}
            disabled={disabled}
            defaultValue={defaultValue}
            getOptionLabel={getOptionLabel}
            onCleared={onCleared}
            getOptionId={getOptionId}
            clearOnSelect
          />
        )}

        {mode === "select" && (
          <Select
            placeholder={placeholder}
            options={options}
            renderOption={renderOption}
            value={value}
            placeholderWhenNoFilteredItems={placeholderWhenNoFilteredItems}
            commonContent={commonContent}
            disabled={disabled}
            defaultValue={defaultValue}
            onChange={onChange}
            getOptionLabel={getOptionLabel}
            onCleared={onCleared}
            getOptionId={getOptionId}
          />
        )}
        {mode === "date" && (
          <div className="date-pickers-wrapper">
            <DatePicker
              value={startDate}
              onChange={onChangeStartDate}
              isPlaceholder={isPlaceholderMinDate}
              disablePast={false}
              checkIsChoosedDay={checkIsChoosedDay}
            />
            <div className="time-divider" />
            <DatePicker
              value={endDate}
              minDate={startDate}
              disablePast={false}
              isPlaceholder={isPlaceholderMaxDate}
              onChange={onChangeEndDate}
              checkIsChoosedDay={checkIsChoosedDay}
            />
          </div>
        )}
        {mode === "checkbox" && (
          <div>
            <Checkbox
              label={""}
              value={value}
              color={"#3273E1"}
              onChange={onChange}
            />
          </div>
        )}
        {mode === "input" && (
          <div className="filter-option-input-wrapper">
            <Input
              variant="square"
              value={inputValue}
              onChange={onChange}
              disabled={disabled}
              placeholder={placeholder}
            />
          </div>
        )}
      </div>
    );
  }
);
